<template>
  <div class="button-delete">
    <button
      type="button"
      class="btn"
      :class="{'no-editing-permission' : !editingPermission}"
      :disabled="disabled"
    >
      <IconDelete
        width="25px"
        height="25px"
      />
    </button>
  </div>
</template>

<script>
import IconDelete from "@/components/atoms/icons/IconDelete.vue"

export default {
  name: "ButtonDelete",
  components: {
    IconDelete,
  },

  props: {
    disabled: { type: Boolean, default: false },
    editingPermission : {
      type: Boolean,
      default: function () {
        return true
      },
    }
  },

  data: () => ({}),
}
</script>

<style lang="scss" scoped>
.btn:disabled {
  opacity: 0.3 !important;
  border: none;
}
.btn.no-editing-permission{
  opacity: 0.3 !important;
  filter:grayscale(1);
  cursor: auto!important;
}
</style>
